import React from "react";
import ReactDOM from "react-dom";
import Chart from "react-google-charts";

const data = [
  ["Element", "Density", { role: "style" }],
  ["Movies", 8.94, "#00A0FF"], // RGB value
  ["Shoping", 10.49, "#9F711E"], // English color name
  ["Books", 19.3, "#B6B6B6"],
  ["Sports", 21.45, "color: #FFF519"] ,// CSS-style declaration
  ["Opera", 20.45, "color: #7000FD"], // CSS-style declaration
  ["Soccer", 18.45, "color: #A1009A"], // CSS-style declaration
  ["Tenns", 19.45, "color: #FF0066"], // CSS-style declaration
  ["Games", 18.45, "color: #539E1C"], // CSS-style declaration
  ["Cars", 15.45, "color: #00FF4A"], // CSS-style declaration
  ["Trucks", 17.45, "color: #00A094"], // CSS-style declaration
  ["Business", 18.45, "color: #000000"], // CSS-style declaration
  ["Money", 20.45, "color: #9F3E3E"], // CSS-style declaration
  ["Stocks", 18.45, "color: #A3A3A3"], // CSS-style declaration
  ["TV Shows", 19.45, "color: #AF0000"], // CSS-style declaration
];
export default ()=> {
    return (
      <div>
        <div className="col-md-6 rounded">
          <h5 className="p-2">Behavioral</h5>
        <Chart
          chartType="ColumnChart"
          width="400px"
        //   height="400px"
          data={data}
        />
        </div>
      </div>
    );
}
